import { useTranslation } from "next-i18next";
import Text from "ab-text";
import Link from "ab-link";

import "./ab-info-additional.scss";

const AdditionalInfo = ({
  variedad,
  denomination,
  denominacionDeOrigen,
  conservacion,
  vida,
  i18n,
  alergenos,
  gradoAlcoholico,
  informacionNutricional,
  elaboradoYEmbotelladoPor,
  ingredientes
}) => {
  const { t } = useTranslation("common", { i18n });
  if (!variedad && !denomination && !denominacionDeOrigen && !conservacion && !vida && !alergenos && !gradoAlcoholico && !informacionNutricional && !elaboradoYEmbotelladoPor) return null
  return (
    <div className="ab-info-additional">
      <h3>{t("informacion-adicional")}</h3>

      <div>
        {variedad ? (
          <div>
            <Text element="span" className="title">
              {t("variedad")}
            </Text>

            <Text>{variedad}</Text>
          </div>
        ) : null}

        {denomination ? (
          <div>
            <Text element="span" className="title">
              {t("denominacion")}
            </Text>

            <Text>{denomination}</Text>
          </div>
        ) : null}
        {denominacionDeOrigen ? (
          <div>
            <Text element="span" className="title">
              {t("denominacion")}
            </Text>

            <Text>{denominacionDeOrigen}</Text>
          </div>
        ) : null}

        {conservacion ? (
          <div>
            <Text element="span" className="title">
              {t("conservacion")}
            </Text>
            <Text>{conservacion}</Text>
          </div>
        ) : null}

        {vida ? (
          <div>
            <Text element="span" className="title">
              {t("vida")}
            </Text>

            <Text>{vida}</Text>
          </div>
        ) : null}

        {alergenos ? (
          <div>
            <Text element="span" className="title">
              {t("alergenos")}
            </Text>

            <Text>{alergenos}</Text>
          </div>
        ) : null}
        {gradoAlcoholico ? (
          <div>
            <Text element="span" className="title">
              {t("gradoAlcoholico")}
            </Text>

            <Text>{gradoAlcoholico}</Text>
          </div>
        ) : null}
        {informacionNutricional ? (
          <div>
            <Text element="span" className="title">
              {t("informacionNutricional")}
            </Text>

            <Text>{informacionNutricional}</Text>
          </div>
        ) : null}
        {elaboradoYEmbotelladoPor ? (
          <div>
            <Text element="span" className="title">
              {t("elaboradoYEmbotelladoPor")}
            </Text>

            <Text>{elaboradoYEmbotelladoPor}</Text>
          </div>
        ) : null}

        {ingredientes ? (
          <div>
            <Text element="span" className="title" style={{ marginBottom: 15 }}>
              {t("ingredientes")}
            </Text>
            <Link
              prefetch={false}
              text={ingredientes.title}
              href={ingredientes.url}
              target={ingredientes.target}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AdditionalInfo;
